module.exports = __webpack_public_path__ + "img/GL_black.86c0b202.svg";